import {
  USER_SETTINGS_STORAGE_KEY,
  type UserSettings,
} from '@pn/core/domain/settings';
import { handleError } from '@pn/core/errors/handleError';
import {
  appActions,
  mapActions,
  tableActions,
  workspaceActions,
} from '@pn/core/storage';
import { apiUserProvider } from '@pn/services/api/user/apiUserProvider';
import { webStorageService } from '@pn/services/storage/webStorageService';

const ls = webStorageService('pn');

export function applyUserSettings(settings: UserSettings): void {
  appActions().updateUnitSystem(settings.unitSystem);
  mapActions().updateMode(settings.mapMode);
  tableActions().sync(settings.tableFields, settings.selectedTemplates);

  Object.entries(settings.pnLayerStyles).map(([itemId, layers]) => {
    workspaceActions().overrideLayers(itemId, layers);
  });
}

export async function saveUserSettings(settings: UserSettings): Promise<void> {
  console.log('%cSaving user settings...', 'color: #4CAF50', settings);

  ls.set(USER_SETTINGS_STORAGE_KEY, settings);

  try {
    await apiUserProvider.updateUserConfig(settings);
  } catch (error) {
    handleError({ error });
  }
}
